import { createAction, props } from '@ngrx/store';
import { PageItem } from '../domain/page-item';
import { PageItemType } from '../domain/page-item-type';
import { PageType } from '../page-edit-screen/page-type';
import { TrayTypeApiModel } from '@cxb/editor-stb-api';

export interface PageVersionId {
  pageVersionId?: string;
}

export type CreatePageItemProps = PageVersionId & Record<'pageItem', PageItem> & Record<'pageType', PageType>;
export type LoadPageItemProps = Record<'id', string> & Record<'discriminatorType', PageItemType> & Record<'pageType', PageType>;
export type LoadPageItemSuccess = PageVersionId & Record<'pageItem', PageItem> & Record<'pageType', PageType>;
export type UpdatePageItemProps = PageVersionId & Record<'pageItem', PageItem> & Record<'pageType', PageType>;
export type DeletePageItemProps = PageVersionId & Record<'id', string> & Record<'trayType', PageItemType> & Record<'pageType', PageType>;
export type ActionSuccessProps = PageVersionId & Record<'pageType', PageType>;
export interface SelectCategoryProps {
  selectedCategory: string;
}
export interface SelectTrayTypeProps {
  selectedTrayType: TrayTypeApiModel;
}
export interface ActionFailProps {
  errorMessage: string;
}

const feature = '[CXB Create tray screen]';

export const clearCxbCreateTrayScreenState = createAction(`${feature} Clear state`);

export const createCxbPageItem = createAction(`${feature} Create page item`, props<CreatePageItemProps>());
export const createCxbPageItemSuccess = createAction(`${feature} Create page item success`, props<ActionSuccessProps>());
export const createCxbPageItemFail = createAction(`${feature} Create page item fail`, props<ActionFailProps>());

export const loadCxbPageItem = createAction(`${feature} Load page item`, props<LoadPageItemProps>());
export const loadCxbPageItemSuccess = createAction(`${feature} Load page item success`, props<LoadPageItemSuccess>());
export const loadCxbPageItemFail = createAction(`${feature} Load page item fail`, props<ActionFailProps>());

export const updateCxbPageItem = createAction(`${feature} Update page item`, props<UpdatePageItemProps>());
export const updateCxbPageItemSuccess = createAction(`${feature} Update page item success`, props<ActionSuccessProps>());
export const updateCxbPageItemFail = createAction(`${feature} Update page item fail`, props<ActionFailProps>());

export const deleteCxbPageItem = createAction(`${feature} Delete page item`, props<DeletePageItemProps>());
export const deleteCxbPageItemSuccess = createAction(`${feature} Delete page item success`, props<ActionSuccessProps>());
export const deleteCxbPageItemFail = createAction(`${feature} Delete page item fail`, props<ActionFailProps>());

export const selectCategory = createAction(`${feature} Select tray category`, props<SelectCategoryProps>());
export const selectTrayType = createAction(`${feature} Select tray type`, props<SelectTrayTypeProps>());
